<template>
  <sub-page title="修改密码">
    <div class="form-page">
      <div class="form-group">
        <input v-model.trim="oldPwd" class="line-input" type="password" placeholder="请输入原密码" />
        <input v-model.trim="newPwd" class="line-input" type="password" placeholder="请输入新密码（8-20位，含字母和数字）" />
        <input v-model.trim="confirmPwd" class="line-input" type="password" placeholder="请再次输入新密码" />
      </div>

      <div class="submit-btn" @click="handleSubmit">确认修改</div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'ChangePassword',
  components: { SubPage },
  data() {
    return {
      oldPwd: '',
      newPwd: '',
      confirmPwd: ''
    }
  },
  methods: {
    handleSubmit() {
      if (!this.oldPwd) {
        this.$alert('请输入原密码')
        return
      }
      if (!/^(?=.*[A-Za-z])(?=.*\d).{8,20}$/.test(this.newPwd)) {
        this.$alert('新密码需为8-20位，且包含字母和数字')
        return
      }
      if (this.newPwd !== this.confirmPwd) {
        this.$alert('两次输入的新密码不一致')
        return
      }
      if (this.oldPwd === this.newPwd) {
        this.$alert('新密码不能与原密码相同')
        return
      }
      this.$alert('密码修改成功')
    }
  }
}
</script>

<style scoped>
.form-page {
  min-height: 100%;
  background: #fff;
  padding: 0 calc(60 * var(--w));
}
.form-group {
  padding-top: calc(40 * var(--w));
}
.line-input {
  width: 100%;
  height: calc(140 * var(--w));
  border: none;
  border-bottom: 1px solid #EBEBEB;
  background: transparent;
  font-size: calc(38 * var(--w));
  color: #323233;
  font-family: inherit;
  outline: none;
}
.line-input::placeholder {
  color: #B5B5B5;
}
.submit-btn {
  margin-top: calc(100 * var(--w));
  height: calc(120 * var(--w));
  border-radius: calc(14 * var(--w));
  background: #2488E8;
  color: #fff;
  font-size: calc(44 * var(--w));
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.submit-btn:active {
  background: #1E77CE;
}
</style>



// WEBPACK FOOTER //
// src/pages/ChangePassword.vue